import { createWebHistory, createRouter } from "vue-router";
import store from "@/store";
const brand = process.env.VUE_APP_BRAND;
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "landing page",
      alias: [""],
      component: () => import("@/views/redirect.vue"),
      meta: {
        // requiresAuth: true,
        title: 'Store Support'
      }
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/page/login")
    },
    {
      path: "/pdf/:sys/:idx",
      name: "Pdf",
      component: () => import("@/views/page/pdf")
    },
    {
      path: "/issue",
      name: "Issue",
      component: () => import("@/views/page/issue")
    },
    {
      path: "/issue/create",
      name: "Issue Create",
      component: () => import("@/views/page/issue/create")
    },
    {
      path: "/issue/detail/:id/:status",
      name: "Issue Detail",
      component: () => import("@/views/page/issue/detail")
    },
    {
      path: "/:catchAll(.*)",
      name: "Page404",
      component: () => import("@/views/page/404")
    }
  ]
});
router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.state.isAuthenticate;

  if (to.path.startsWith('/pdf')) {
    return next();
  }

  if (!isLoggedIn && to.path !== '/login') {
    return next('/login');
  }

  if (isLoggedIn && to.path === '/login') {
    return next('/issue');
  }

  next();
});
export default router;
